import React from 'react';
import EmptyState from '../EmptyState';
import {FormattedMessage} from '../FormattedComponents';
import messages from './messages';

export const GuideNotAvailable = () => (
  <EmptyState
    title={<FormattedMessage {...messages.title} />}
    description={<FormattedMessage {...messages.description} />}
    icon={'not-found'}
    centered
    topSpacer
  />
);

export default GuideNotAvailable;
